'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _dec2, _class3, _dec3, _dec4, _dec5, _class4, _class5, _temp2;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reduxForm = require('redux-form');

var _reactIntl = require('react-intl');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _isomorphicFetch = require('isomorphic-fetch');

var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _forms = require('utils/forms');

var _pacomo = require('utils/pacomo');

var _utilityFunctions = require('utils/utilityFunctions');

var _reduxUi = require('redux-ui');

var _reduxUi2 = _interopRequireDefault(_reduxUi);

var _components2 = require('components');

var _forms2 = require('metadata/forms');

var _reactRedux = require('react-redux');

var _forms3 = require('../../../utils/forms');

var _userActions = require('../../../actions/userActions');

var _travelStyles = require('../../../utils/mappings/travel-styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    FlightOverride: {
        displayName: 'FlightOverride'
    },
    FlightDetails: {
        displayName: 'FlightDetails'
    },
    FlightInformation: {
        displayName: 'FlightInformation'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/Users/gareth.chou/Documents/GAdventures/g-rex/app/components/RequirementSet/forms/FlightInformation.js',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var flightOverrideCodes = ['ARRIVAL_PRE_THREE_WEEKS', 'DEPARTURE_POST_THREE_WEEKS', 'PREVIOUS_TOUR_IN_CITY'];
var syncValidation = (0, _forms.formSyncValidation)({
    eTicketValues: ['internationalTicketNumber']
});

var renderSegments = function renderSegments(_ref) {
    var className = _ref.className,
        fields = _ref.fields,
        intl = _ref.intl,
        hiddenValues = _ref.hiddenValues,
        flightLabelId = _ref.flightLabelId,
        flight = _ref.flight,
        is424 = _ref.is424,
        error = _ref.meta.error,
        resourceDataCall = _ref.resourceDataCall;

    return _react3.default.createElement(
        'div',
        null,
        fields.map(function (segment, i) {
            return _react3.default.createElement(
                'div',
                { className: 'outer-fields', key: i },
                (0, _forms3.renderSegmentErrorMessages)(resourceDataCall, segment),
                i > 0 && _react3.default.createElement(
                    'div',
                    { className: 'row' },
                    _react3.default.createElement(
                        'div',
                        { className: 'label' },
                        _react3.default.createElement(
                            'div',
                            { className: 'plane-header' },
                            _react3.default.createElement(_components2.IconPlane, null)
                        )
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'fields' },
                        _react3.default.createElement(
                            'div',
                            { className: 'connection-header' },
                            _react3.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'formFlightInformation.connectionX',
                                defaultMessage: 'Connection {x}',
                                values: { x: i } }),
                            i > 0 && flight.editable && _react3.default.createElement(
                                'span',
                                { className: 'close-connection',
                                    onClick: function onClick(e) {
                                        e.preventDefault();
                                        fields.remove(i);
                                    } },
                                _react3.default.createElement('img', { src: require('theme/img/close.png') })
                            )
                        )
                    )
                ),
                _react3.default.createElement(
                    'div',
                    { className: 'row' },
                    _react3.default.createElement(
                        'label',
                        { className: 'label', htmlFor: flightLabelId + '_seg-' + i + '.airline' },
                        i === 0 && _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'formLabels.flight' }),
                        i > 0 && _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'formLabels.connectingFlight' })
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'fields' },
                        _react3.default.createElement(
                            'div',
                            { className: 'left' },
                            _react3.default.createElement(
                                'div',
                                { className: 'wrapper allow-overflow' },
                                _react3.default.createElement(_reduxForm.Field, {
                                    id: flightLabelId + '_seg-' + i + '.airline',
                                    name: segment + '.airline.code',
                                    hiddenValues: hiddenValues,
                                    component: _components2.Combobox,
                                    type: 'text',
                                    fieldClass: 'field-small',
                                    requirement: flight,
                                    helpText: _react3.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'formFlightInformation.airline',
                                        defaultMessage: 'Airline Code' }) })
                            )
                        ),
                        _react3.default.createElement(
                            'div',
                            { className: 'left' },
                            _react3.default.createElement(
                                'div',
                                { className: 'wrapper' },
                                _react3.default.createElement(_reduxForm.Field, {
                                    id: flightLabelId + '_seg-' + i + '.flightNumber',
                                    name: segment + '.flight_number',
                                    hiddenValues: hiddenValues,
                                    component: _components2.Input,
                                    type: 'text',
                                    fieldClass: 'field-small',
                                    requirement: flight,
                                    helpText: _react3.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'formFlightInformation.flightNumber',
                                        defaultMessage: 'Flight Number' }) })
                            )
                        )
                    )
                ),
                _react3.default.createElement(
                    'div',
                    { className: 'row' },
                    _react3.default.createElement(
                        'label',
                        { className: 'label' },
                        _react3.default.createElement(
                            'strong',
                            null,
                            'Departure'
                        )
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'fields' },
                        _react3.default.createElement('br', null)
                    )
                ),
                _react3.default.createElement(
                    'div',
                    { className: 'row' },
                    _react3.default.createElement(
                        'label',
                        { className: 'label', htmlFor: flightLabelId + '_seg-' + i + '.departureAirport' },
                        i === 0 && _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'formLabels.departureAirport' }),
                        i > 0 && _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'formLabels.connectingAirport' })
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'fields' },
                        _react3.default.createElement(_reduxForm.Field, {
                            id: flightLabelId + '_seg-' + i + '.departureAirport',
                            name: segment + '.departure_airport.code',
                            hiddenValues: hiddenValues,
                            component: _components2.SelectCachedInput,
                            intl: intl,
                            loadResource: 'airports',
                            queryParam: 'iata_code',
                            resultParsing: function resultParsing(results) {
                                return results.filter(function (result) {
                                    return result.iata_code && (result.active === undefined || result.active);
                                }).map(function (result) {
                                    return {
                                        label: '(' + result.iata_code + ') ' + result.name,
                                        value: result.iata_code
                                    };
                                });
                            },
                            helpText: i === 0 ? _react3.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'formFlightInformation.departureAirportHelp',
                                defaultMessage: 'The airport this flight leaves from' }) : _react3.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'formFlightInformation.connectingAirportHelp',
                                defaultMessage: 'The airport where you change flights' }),
                            requirement: flight })
                    )
                ),
                is424 && _react3.default.createElement(
                    'div',
                    { className: 'row' },
                    _react3.default.createElement(
                        'label',
                        { className: 'label', htmlFor: flightLabelId + '_seg-' + i + '.departureTime' },
                        _react3.default.createElement(
                            'span',
                            null,
                            'Departure Date'
                        )
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'fields' },
                        _react3.default.createElement(_reduxForm.Field, {
                            id: flightLabelId + '_seg-' + i + '.departureTime',
                            name: segment + '.departure_datetime_local',
                            hiddenValues: hiddenValues,
                            component: _components2.DatetimeInput,
                            requirement: flight })
                    )
                ),
                !is424 && _react3.default.createElement(
                    'div',
                    { className: 'row' },
                    _react3.default.createElement(
                        'label',
                        { className: 'label', htmlFor: flightLabelId + '_seg-' + i + '.departureTime' },
                        _react3.default.createElement(
                            'span',
                            null,
                            'Departure Date'
                        )
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'fields' },
                        _react3.default.createElement(_reduxForm.Field, {
                            id: flightLabelId + '_seg-' + i + '.departureTime',
                            name: segment + '.departure_datetime_local',
                            hiddenValues: hiddenValues,
                            component: _components2.DatetimeInput,
                            requirement: flight })
                    )
                ),
                _react3.default.createElement(
                    'div',
                    { className: 'travelDirection', style: {
                            display: is424 ? 'block' : 'none'
                        } },
                    _react3.default.createElement(
                        'div',
                        { className: 'row' },
                        _react3.default.createElement(
                            'label',
                            { className: 'label' },
                            _react3.default.createElement(
                                'strong',
                                null,
                                'Arrival'
                            )
                        ),
                        _react3.default.createElement(
                            'div',
                            { className: 'fields' },
                            '(Optional)'
                        )
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'row' },
                        _react3.default.createElement(
                            'label',
                            { className: 'label', htmlFor: flightLabelId + '_seg-' + i + '.arrivalAirport' },
                            _react3.default.createElement(
                                'span',
                                null,
                                'To Airport ',
                                _react3.default.createElement('br', null),
                                '(Optional)'
                            )
                        ),
                        _react3.default.createElement(
                            'div',
                            { className: 'fields' },
                            _react3.default.createElement(_reduxForm.Field, {
                                id: flightLabelId + '_seg-' + i + '.arrivalAirport',
                                name: segment + '.arrival_airport.code',
                                hiddenValues: hiddenValues,
                                component: _components2.SelectCachedInput,
                                intl: intl,
                                loadResource: 'airports',
                                queryParam: 'iata_code',
                                resultParsing: function resultParsing(results) {
                                    return results.filter(function (result) {
                                        return result.iata_code && (result.active === undefined || result.active);
                                    }).map(function (result) {
                                        return {
                                            label: '(' + result.iata_code + ') ' + result.name,
                                            value: result.iata_code
                                        };
                                    });
                                },
                                requirement: flight })
                        )
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'row' },
                        _react3.default.createElement(
                            'label',
                            { className: 'label', htmlFor: flightLabelId + '_seg-' + i + '.arrivalTime' },
                            _react3.default.createElement(
                                'span',
                                null,
                                'Arrival Date ',
                                _react3.default.createElement('br', null),
                                '(Optional)'
                            )
                        ),
                        _react3.default.createElement(
                            'div',
                            { className: 'fields' },
                            _react3.default.createElement(_reduxForm.Field, {
                                id: flightLabelId + '_seg-' + i + '.arrivalTime',
                                name: segment + '.arrival_datetime_local',
                                hiddenValues: hiddenValues,
                                component: _components2.DatetimeInput,
                                requirement: flight })
                        )
                    )
                )
            );
        }),
        flight.editable && _react3.default.createElement(
            'div',
            null,
            fields.length > 0 && _react3.default.createElement(
                'div',
                { className: 'buttons' },
                _react3.default.createElement('div', { className: 'label' }),
                _react3.default.createElement(
                    'div',
                    { className: 'fields button-fields' },
                    _react3.default.createElement(
                        'button',
                        {
                            className: 'add-connection',
                            onClick: function onClick(e) {
                                e.preventDefault();
                                fields.push({});
                            },
                            disabled: !flight.editable },
                        _react3.default.createElement(
                            'span',
                            { className: 'formatted-link' },
                            _react3.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'formFlightInformation.addConnection',
                                defaultMessage: 'Add connection' })
                        )
                    )
                )
            ),
            _react3.default.createElement(
                'div',
                { className: 'buttons' },
                _react3.default.createElement('div', { className: 'label' }),
                _react3.default.createElement(
                    'div',
                    { className: 'fields button-fields' },
                    _react3.default.createElement(
                        'button',
                        {
                            className: 'clear-flight',
                            onClick: function onClick(e) {
                                e.preventDefault();
                                fields.removeAll();
                                fields.push({});
                            } },
                        _react3.default.createElement(
                            'span',
                            { className: 'formatted-link' },
                            _react3.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'formFlightInformation.clearFlight',
                                defaultMessage: 'Clear Flight' })
                        )
                    )
                ),
                _react3.default.createElement(_components2.FieldHelpErrorText, {
                    touched: true // have to force this because FieldArray doesn't have meta.touched
                    , error: error })
            )
        )
    );
};
renderSegments = (0, _pacomo.pacomoTransformer)(renderSegments);

var FlightOverride = _wrapComponent('FlightOverride')((_dec = (0, _reduxUi2.default)(), _dec(_class = (0, _reactIntl.injectIntl)(_class = (0, _pacomo.pacomoDecorator)(_class = function (_React$Component) {
    (0, _inherits3.default)(FlightOverride, _React$Component);

    function FlightOverride() {
        var _ref2;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, FlightOverride);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = FlightOverride.__proto__ || (0, _getPrototypeOf2.default)(FlightOverride)).call.apply(_ref2, [this].concat(args))), _this), _this.handleIsFlight = function (event) {
            var showFlight = !!event.target.value;
            var _this$props = _this.props,
                _this$props$input = _this$props.input,
                value = _this$props$input.value,
                onChange = _this$props$input.onChange,
                overrideReasons = _this$props.overrideReasons,
                uniqueFlightId = _this$props.uniqueFlightId,
                isAFlight = _this$props.isAFlight,
                isNotAFlight = _this$props.isNotAFlight,
                isFlights = _this$props.isFlights;


            var nonFlightOverrideReasons = overrideReasons.filter(function (reason) {
                return !flightOverrideCodes.includes(reason.code);
            });

            // Clear override value if the customer is taking a flight
            //  and there are no flight overrides set
            if (showFlight && value && !flightOverrideCodes.includes(value)) {
                onChange('');
            } else if (!showFlight && (!value || flightOverrideCodes.includes(value))) {
                // Select first override in select dropdown
                onChange(nonFlightOverrideReasons[0].code);
            }
            if (showFlight) {
                isAFlight(uniqueFlightId);
            } else {
                isNotAFlight(uniqueFlightId);
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(FlightOverride, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.setState({
                isFlight: this.props.isFlights.includes(this.props.uniqueFlightId)
            });
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.props.isFlights !== nextProps.isFlights) {
                this.setState({
                    isFlight: nextProps.isFlights.includes(this.props.uniqueFlightId)
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                id = _props.id,
                hiddenValues = _props.hiddenValues,
                input = _props.input,
                meta = _props.meta,
                flight = _props.flight,
                overrideReasons = _props.overrideReasons,
                flightType = _props.flightType,
                departureService = _props.departureService,
                assocDFDepService = _props.assocDFDepService,
                intl = _props.intl;


            var showPreviousTourOverride = overrideReasons.findIndex(function (reason) {
                return reason.code === 'PREVIOUS_TOUR_IN_CITY';
            }) > -1 && assocDFDepService;

            var showArrivalTooSoonOverride = overrideReasons.findIndex(function (reason) {
                return reason.code === 'ARRIVAL_PRE_THREE_WEEKS';
            }) > -1 && flightType === 'ARRIVAL';

            var arrivalTooSoonDate = void 0;
            if (showArrivalTooSoonOverride) {
                var tempDate = new Date(departureService.start_date);
                tempDate.setUTCDate(tempDate.getUTCDate() - 21);
                arrivalTooSoonDate = tempDate.getUTCFullYear() + '-' + (tempDate.getUTCMonth() + 1) + '-' + tempDate.getUTCDate();
            }

            var showDepartureTooLateOverride = overrideReasons.findIndex(function (reason) {
                return reason.code === 'DEPARTURE_POST_THREE_WEEKS';
            }) > -1 && flightType === 'DEPARTURE';

            var departureTooLateDate = void 0;
            if (showDepartureTooLateOverride) {
                var _tempDate = new Date(departureService.finish_date);
                _tempDate.setUTCDate(_tempDate.getUTCDate() + 21);
                departureTooLateDate = _tempDate.getUTCFullYear() + '-' + (_tempDate.getUTCMonth() + 1) + '-' + _tempDate.getUTCDate();
            }

            var nonFlightOverrideReasons = overrideReasons.filter(function (reason) {
                return !flightOverrideCodes.includes(reason.code);
            });

            var overrideSection = void 0;
            if (this.state.isFlight) {
                overrideSection = _react3.default.createElement(
                    'div',
                    null,
                    showPreviousTourOverride && _react3.default.createElement(
                        'div',
                        { className: 'row' },
                        _react3.default.createElement(
                            'div',
                            { className: 'label' },
                            _react3.default.createElement('input', {
                                id: id + '-prevTourInCity',
                                type: 'checkbox',
                                checked: input.value && input.value === 'PREVIOUS_TOUR_IN_CITY',
                                onChange: function onChange(event) {
                                    if (input.value === 'PREVIOUS_TOUR_IN_CITY') {
                                        input.onChange('');
                                    } else {
                                        input.onChange('PREVIOUS_TOUR_IN_CITY');
                                    }
                                },
                                disabled: !flight.editable })
                        ),
                        _react3.default.createElement(
                            'div',
                            { className: 'fields' },
                            _react3.default.createElement(
                                'div',
                                { className: 'check' },
                                _react3.default.createElement(
                                    'label',
                                    { htmlFor: id + '-prevTourInCity' },
                                    _react3.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'flightInformation.sameAsLastDeparture',
                                        defaultMessage: 'Same as departure from {lastDeparture}',
                                        values: {
                                            lastDeparture: assocDFDepService.name
                                        } })
                                )
                            )
                        )
                    ),
                    showArrivalTooSoonOverride && _react3.default.createElement(
                        'div',
                        { className: 'row' },
                        _react3.default.createElement(
                            'div',
                            { className: 'label' },
                            _react3.default.createElement('input', {
                                id: id + '-arrivalTooSoon',
                                type: 'checkbox',
                                checked: input.value && input.value === 'ARRIVAL_PRE_THREE_WEEKS',
                                onChange: function onChange(event) {
                                    if (input.value === 'ARRIVAL_PRE_THREE_WEEKS') {
                                        input.onChange('');
                                    } else {
                                        input.onChange('ARRIVAL_PRE_THREE_WEEKS');
                                    }
                                },
                                disabled: !flight.editable })
                        ),
                        _react3.default.createElement(
                            'div',
                            { className: 'fields' },
                            _react3.default.createElement(
                                'div',
                                { className: 'check' },
                                _react3.default.createElement(
                                    'label',
                                    { htmlFor: id + '-arrivalTooSoon' },
                                    _react3.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'flightInformation.arrivalTooSoon',
                                        defaultMessage: 'My flight arrives before {twentyOneDaysPriorToTour}',
                                        values: {
                                            twentyOneDaysPriorToTour: _react3.default.createElement(_reactIntl.FormattedDate, {
                                                value: arrivalTooSoonDate,
                                                timeZone: 'UTC',
                                                year: 'numeric', month: 'short', day: 'numeric' })
                                        } })
                                )
                            )
                        )
                    ),
                    showDepartureTooLateOverride && _react3.default.createElement(
                        'div',
                        { className: 'row' },
                        _react3.default.createElement(
                            'div',
                            { className: 'label' },
                            _react3.default.createElement('input', {
                                id: id + '-departureTooLate',
                                type: 'checkbox',
                                checked: input.value && input.value === 'DEPARTURE_POST_THREE_WEEKS',
                                onChange: function onChange(event) {
                                    if (input.value === 'DEPARTURE_POST_THREE_WEEKS') {
                                        input.onChange('');
                                    } else {
                                        input.onChange('DEPARTURE_POST_THREE_WEEKS');
                                    }
                                },
                                disabled: !flight.editable })
                        ),
                        _react3.default.createElement(
                            'div',
                            { className: 'fields' },
                            _react3.default.createElement(
                                'div',
                                { className: 'check' },
                                _react3.default.createElement(
                                    'label',
                                    { htmlFor: id + '-departureTooLate' },
                                    _react3.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'flightInformation.departureTooLate',
                                        defaultMessage: 'My flight departs after {twentyOneDaysAfterTour}',
                                        values: {
                                            twentyOneDaysAfterTour: _react3.default.createElement(_reactIntl.FormattedDate, {
                                                value: departureTooLateDate,
                                                timeZone: 'UTC',
                                                year: 'numeric', month: 'short', day: 'numeric' })
                                        } })
                                )
                            )
                        )
                    )
                );
            } else {
                overrideSection = _react3.default.createElement(
                    'div',
                    { className: 'row' },
                    _react3.default.createElement('div', { className: 'label' }),
                    _react3.default.createElement(
                        'div',
                        { className: 'fields' },
                        _react3.default.createElement(_components2.Input, {
                            input: input,
                            name: input.name,
                            type: 'select',
                            requirement: flight,
                            options: nonFlightOverrideReasons.map(function (reason) {
                                return {
                                    label: intl.formatMessage(_forms2.formOverrides.flightDetails[flightType][reason.code]),
                                    value: reason.code
                                };
                            }),
                            hideDefaultSelectOption: true,
                            meta: meta })
                    )
                );
            }
            var arrivingLeavingByLabel = flightType === 'ARRIVAL' ? _react3.default.createElement(_reactIntl.FormattedMessage, {
                id: 'formFlightInformation.arrivingBy',
                defaultMessage: 'I\'m arriving by...' }) : _react3.default.createElement(_reactIntl.FormattedMessage, {
                id: 'formFlightInformation.leavingBy',
                defaultMessage: 'I\'m leaving by...' });

            return _react3.default.createElement(
                'div',
                null,
                _react3.default.createElement(
                    'div',
                    { className: 'row' },
                    _react3.default.createElement(
                        'div',
                        { className: 'label' },
                        _react3.default.createElement(
                            'label',
                            { htmlFor: id + '-arrivingLeavingBy' },
                            arrivingLeavingByLabel
                        )
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'fields' },
                        _react3.default.createElement(
                            'label',
                            { className: 'radio-option' },
                            _react3.default.createElement('input', {
                                type: 'radio',
                                name: id + '-arrivingLeavingBy',
                                value: 'show',
                                checked: this.state.isFlight,
                                disabled: !flight.editable,
                                onChange: this.handleIsFlight }),
                            _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'formLabels.flight' })
                        ),
                        _react3.default.createElement(
                            'label',
                            { className: 'radio-option' },
                            _react3.default.createElement('input', {
                                type: 'radio',
                                name: id + '-arrivingLeavingBy',
                                value: '' // hide
                                , checked: !this.state.isFlight,
                                disabled: !flight.editable,
                                onChange: this.handleIsFlight }),
                            _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'formLabels.other' })
                        )
                    )
                ),
                overrideSection
            );
        }
    }]);
    return FlightOverride;
}(_react3.default.Component)) || _class) || _class) || _class));

var FlightDetails = _wrapComponent('FlightDetails')((_dec2 = (0, _reduxUi2.default)(), _dec2(_class3 = (0, _pacomo.pacomoDecorator)(_class3 = function (_Component) {
    (0, _inherits3.default)(FlightDetails, _Component);

    function FlightDetails(props) {
        (0, _classCallCheck3.default)(this, FlightDetails);

        var _this2 = (0, _possibleConstructorReturn3.default)(this, (FlightDetails.__proto__ || (0, _getPrototypeOf2.default)(FlightDetails)).call(this, props));

        var flightDetailsIsVisible = props.flightDetailsIsVisible,
            uniqueFlightId = props.uniqueFlightId;

        _this2.state = {
            hideFlightDetails: !flightDetailsIsVisible.includes(uniqueFlightId)
        };
        return _this2;
    }

    (0, _createClass3.default)(FlightDetails, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.hideFlightDetailsIfOverride(this.props);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.props.initialValues !== nextProps.initialValues) {
                this.hideFlightDetailsIfOverride(nextProps);
            }

            if (this.props.flightDetailsIsVisible !== nextProps.flightDetailsIsVisible) {
                this.hideFlightDetailsIfOverride(nextProps);
            }
        }
    }, {
        key: 'hideFlightDetailsIfOverride',
        value: function hideFlightDetailsIfOverride(_ref3) {
            var flightDetailsIsVisible = _ref3.flightDetailsIsVisible;

            this.setState({
                hideFlightDetails: !flightDetailsIsVisible.includes(this.props.uniqueFlightId)
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props2 = this.props,
                array = _props2.array,
                initialValues = _props2.initialValues,
                hiddenValues = _props2.hiddenValues,
                flight = _props2.flight,
                departureService = _props2.departureService,
                assocDFDepService = _props2.assocDFDepService,
                flightLabelId = _props2.flightLabelId,
                flightType = _props2.flightType,
                intl = _props2.intl,
                resourceDataCall = _props2.resourceDataCall,
                hideFlightDetails = _props2.hideFlightDetails,
                showFlightDetails = _props2.showFlightDetails,
                uniqueFlightId = _props2.uniqueFlightId,
                isAFlight = _props2.isAFlight,
                isNotAFlight = _props2.isNotAFlight,
                isFlights = _props2.isFlights,
                is424 = _props2.is424;

            // TODO: Remove once complete/incomplete check in API is fixed

            if (flight.fieldResourceHrefsByType.flight_statuses || flight.applied_overrides.length > 0) {
                flight.status = 'COMPLETE';
            } else {
                flight.status = 'INCOMPLETE';
            }
            // END TODO

            var valuePath = (0, _forms.generateValuePath)({
                requirement: flight,
                resourceType: 'flight_statuses'
            });
            var overrideValuePath = (0, _forms.generateValuePath)({
                requirement: flight,
                resourceType: 'overrides'
            });

            return _react3.default.createElement(
                'fieldset',
                null,
                _react3.default.createElement(_components2.CompletedByTag, { requirement: flight }),
                _react3.default.createElement(
                    'div',
                    { className: 'title' },
                    _react3.default.createElement(
                        'div',
                        { className: 'flightToX' },
                        _react3.default.createElement(
                            'div',
                            { className: 'label' },
                            _react3.default.createElement(
                                'span',
                                { className: 'flight-type' },
                                flightType === 'ARRIVAL' && _react3.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'formFlightInformation.arrival',
                                    defaultMessage: 'Arrival to tour' }),
                                flightType === 'DEPARTURE' && _react3.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'formFlightInformation.departure',
                                    defaultMessage: 'Departure from tour' })
                            )
                        ),
                        _react3.default.createElement(
                            'div',
                            { className: 'fields' },
                            _react3.default.createElement(
                                'span',
                                { className: 'trip-name' },
                                departureService.name
                            ),
                            flightType === 'ARRIVAL' && _react3.default.createElement(
                                'span',
                                { className: 'flight-date' },
                                '(',
                                _react3.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'formFlightInformation.tourStarts',
                                    defaultMessage: 'tour starts' }),
                                '\xA0',
                                _react3.default.createElement(_reactIntl.FormattedDate, {
                                    value: departureService.start_date,
                                    year: 'numeric', month: 'short', day: 'numeric', timeZone: 'UTC' }),
                                ')'
                            ),
                            flightType === 'DEPARTURE' && _react3.default.createElement(
                                'span',
                                { className: 'flight-date' },
                                '(',
                                _react3.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'formFlightInformation.tourEnds',
                                    defaultMessage: 'tour ends' }),
                                '\xA0',
                                _react3.default.createElement(_reactIntl.FormattedDate, {
                                    value: departureService.finish_date,
                                    year: 'numeric', month: 'short', day: 'numeric', timeZone: 'UTC' }),
                                ')'
                            )
                        )
                    )
                ),
                _react3.default.createElement(_reduxForm.Field, {
                    id: flightLabelId + '.override',
                    name: overrideValuePath + '.reason.code',
                    component: FlightOverride,
                    flight: flight,
                    overrideReasons: flight.override_reasons,
                    flightType: flightType,
                    departureService: departureService,
                    assocDFDepService: assocDFDepService,
                    uniqueFlightId: uniqueFlightId,
                    isAFlight: isAFlight,
                    isNotAFlight: isNotAFlight,
                    isFlights: isFlights,
                    normalize: function normalize(value, prevVal, allVals) {
                        // If an override is selected, clear segments; hide flight details
                        // Else, if override is unselected, show flight details
                        if (value && !_this3.state.hideFlightDetails) {
                            // Reset segments value to initial
                            var initialVal = (0, _utilityFunctions.getResourceValue)(valuePath + '.segments', initialValues);
                            array.removeAll(valuePath + '.segments');
                            initialVal.forEach(function (segment) {
                                array.push(valuePath + '.segments', segment);
                            });
                            hideFlightDetails(uniqueFlightId);
                        } else if (!value && _this3.state.hideFlightDetails) {
                            showFlightDetails(uniqueFlightId);
                        }
                        return value;
                    } }),
                valuePath && !this.state.hideFlightDetails && _react3.default.createElement(_reduxForm.FieldArray, {
                    key: flightLabelId,
                    name: valuePath + '.segments',
                    component: renderSegments,
                    props: {
                        intl: intl,
                        hiddenValues: hiddenValues,
                        flightLabelId: flightLabelId,
                        flight: flight,
                        is424: is424,
                        resourceDataCall: resourceDataCall
                    } }),
                !valuePath && _react3.default.createElement(
                    'div',
                    { className: 'alert alert-danger', role: 'alert' },
                    _react3.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'formFlightInformation.cannotLoadFlight',
                        defaultMessage: 'Could not load flight details.' })
                )
            );
        }
    }]);
    return FlightDetails;
}(_react2.Component)) || _class3) || _class3));

// Stubs for transfer forfeiting doc req


var forfeitedTransferStub = {
    FORFEITED_ARRIVAL_TRANSFER: function FORFEITED_ARRIVAL_TRANSFER(bookingCompany, bookingMeta) {
        if (bookingCompany && bookingCompany.name == 'TruTravels') {
            return _react3.default.createElement(_reactIntl.FormattedMessage, {
                id: 'formAcknowledgements.forfeitedArrivalTransfer',
                defaultMessage: '{stubText}',
                values: {
                    stubText: _react3.default.createElement(
                        'div',
                        null,
                        _react3.default.createElement(
                            'h4',
                            null,
                            _react3.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'formAcknowledgements.Tru.forfeitedArrivalTransferTitle',
                                defaultMessage: 'Arriving Early?' })
                        ),
                        _react3.default.createElement(
                            'div',
                            null,
                            _react3.default.createElement(
                                'p',
                                null,
                                _react3.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'formAcknowledgements.Tru.forfeitedArrivalTransferText',
                                    defaultMessage: 'The Flight Details you have entered show you arriving before\n                                             the start date of the tour.'
                                })
                            ),
                            _react3.default.createElement(
                                'p',
                                null,
                                _react3.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'formAcknowledgements.Tru.forfeitedArrivalTransferText2',
                                    defaultMessage: 'If you would like to book a pre-night and airport transfer,\n                                             please get in touch with our team at info@trutravels.com\n                                            ',
                                    values: {
                                        email: bookingCompany.email
                                    }
                                })
                            ),
                            _react3.default.createElement(
                                'p',
                                null,
                                _react3.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'formAcknowledgements.Tru.forfeitedArrivalTransferText3',
                                    defaultMessage: 'Alternatively, if you have booked elsewhere to stay and\n                                             plan on meeting everyone at the start hotel, please tick the box\n                                              \u201CI do not require a transfer\u201D\n\n                                            ',
                                    values: {
                                        email: bookingCompany.email
                                    }
                                })
                            )
                        )
                    )
                } });
        } else {
            return _react3.default.createElement(_reactIntl.FormattedMessage, {
                id: 'formAcknowledgements.forfeitedArrivalTransfer',
                defaultMessage: '{stubText}',
                values: {
                    stubText: _react3.default.createElement(
                        'div',
                        null,
                        _react3.default.createElement(
                            'h4',
                            null,
                            _react3.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'formAcknowledgements.forfeitedArrivalTransferTitle',
                                defaultMessage: 'Forfeited Arrival Transfer' })
                        ),
                        _react3.default.createElement(
                            'div',
                            null,
                            _react3.default.createElement(
                                'p',
                                null,
                                _react3.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'formAcknowledgements.forfeitedArrivalTransferText',
                                    defaultMessage: 'Hey there! It looks like you have entered\n                                                flight details that do not match up with the start date\n                                                of your tour. As there is an arrival airport to hotel transfer\n                                                included as a part of this tour, you will need to re-renter your\n                                                flight details to match, or inquire about purchasing additional\n                                                accommodation with us. To book your pre-tour or post-tour accommodation,\n                                                please contact us or your travel agent for further details.'
                                })
                            ),
                            _react3.default.createElement(
                                'p',
                                null,
                                _react3.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'formAcknowledgements.forfeitedArrivalTransferText2',
                                    defaultMessage: 'If you are planning to book additional accommodation\n                                                with us, please DO NOT check this box. Please note that this action\n                                                cannot be reverted by un-checking the box. Please contact\n                                                {email} if you need to revert your selection.',
                                    values: {
                                        email: bookingMeta && (0, _travelStyles.isNatGeoSignature)(bookingMeta) ? 'natgeosignature@gadventures.com' : bookingCompany.email
                                    }
                                })
                            ),
                            _react3.default.createElement(
                                'p',
                                null,
                                _react3.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'formAcknowledgements.forfeitedArrivalTransferText3',
                                    defaultMessage: 'PLEASE NOTE THAT BY CHECKING THIS BOX YOU ACKNOWLEDGE\n                                                THAT NO TRANSFER WILL BE PROVIDED, REGARDLESS IF WE HAVE YOUR\n                                                FLIGHT DETAILS ON FILE OR NOT.'
                                })
                            )
                        )
                    )
                } });
        }
    },
    FORFEITED_DEPARTURE_TRANSFER: function FORFEITED_DEPARTURE_TRANSFER() {
        return _react3.default.createElement(_reactIntl.FormattedMessage, {
            id: 'formAcknowledgements.forfeitedDepartureTransfer',
            defaultMessage: '{stubText}',
            values: {
                stubText: _react3.default.createElement(
                    'div',
                    null,
                    _react3.default.createElement(
                        'h4',
                        null,
                        _react3.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'formAcknowledgements.forfeitedDepartureTransferTitle',
                            defaultMessage: 'Forfeited Departure Transfer' })
                    ),
                    _react3.default.createElement(
                        'p',
                        null,
                        _react3.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'formAcknowledgements.forfeitedDepartureTransferText',
                            defaultMessage: 'Hey there! It looks like you have entered flight details\n                                that do not match up with the end date of your tour. As there is\n                                an hotel to departure airport transfer included as a part of\n                                this tour, you will need to re-renter your flight details to match, or\n                                inquire about purchasing additional accommodation with us. To book your\n                                pre-tour or post-tour accommodation, please contact us or your travel agent\n                                for further details.'
                        })
                    )
                )
            } });
    }
};

var unverifiedFlightsStub = function unverifiedFlightsStub() {
    return _react3.default.createElement(_reactIntl.FormattedMessage, {
        id: 'flightInformation.unverifiedFlightsStub',
        defaultMessage: '{stubText}',
        values: {
            stubText: _react3.default.createElement(
                'div',
                null,
                _react3.default.createElement(
                    'h4',
                    null,
                    _react3.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'flightInformation.unverifiedFlightsStub.title',
                        defaultMessage: 'We\'ll Review Your Flights' })
                ),
                _react3.default.createElement(
                    'p',
                    null,
                    _react3.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'flightInformation.unverifiedFlightsStub.text',
                        defaultMessage: 'Hey there! Thank you for entering your flight details.\n                            We need to double check your flight details, but don\u2019t worry, we\u2019ll review,\n                            and contact you if we need additional confirmation.'
                    })
                )
            )
        }
    });
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        setPassengerIdForFlightCheck: function setPassengerIdForFlightCheck(id) {
            return dispatch((0, _userActions.setPassengerIdForFlightCheck)(id));
        },
        setIsZeroScheduleFlow: function setIsZeroScheduleFlow(state) {
            return dispatch((0, _userActions.setIsZeroScheduleFlow)(state));
        }
    };
};
var mapStateToProps = function mapStateToProps(state) {
    return {
        resourceDataCall: state.apiCalls.resourceData,
        bookingMeta: state.bookingMeta
    };
};

var FlightInformation = _wrapComponent('FlightInformation')((_dec3 = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec4 = (0, _reduxForm.reduxForm)({
    form: 'flightInformation',
    enableReinitialize: true,
    validate: syncValidation
}), _dec5 = (0, _reduxUi2.default)(), _dec3(_class4 = _dec4(_class4 = (0, _reactIntl.injectIntl)(_class4 = _dec5(_class4 = (0, _pacomo.pacomoDecorator)(_class4 = (_temp2 = _class5 = function (_Component2) {
    (0, _inherits3.default)(FlightInformation, _Component2);

    function FlightInformation(props) {
        (0, _classCallCheck3.default)(this, FlightInformation);

        var _this4 = (0, _possibleConstructorReturn3.default)(this, (FlightInformation.__proto__ || (0, _getPrototypeOf2.default)(FlightInformation)).call(this, props));

        _this4.state = {
            intlTicRenderProps: undefined,
            flightDetailsIsVisible: [],
            isFlights: [],
            is424: false,
            hasSeen424: false
        };

        _this4.getFlights = _this4.getFlights.bind(_this4);

        if (!(typeof _this4.getFlights === 'function')) {
            throw new TypeError('Value of "this.getFlights" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this4.getFlights));
        }

        _this4.hideFlightDetails = _this4.hideFlightDetails.bind(_this4);

        if (!(typeof _this4.hideFlightDetails === 'function')) {
            throw new TypeError('Value of "this.hideFlightDetails" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this4.hideFlightDetails));
        }

        _this4.showFlightDetails = _this4.showFlightDetails.bind(_this4);

        if (!(typeof _this4.showFlightDetails === 'function')) {
            throw new TypeError('Value of "this.showFlightDetails" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this4.showFlightDetails));
        }

        _this4.isAFlight = _this4.isAFlight.bind(_this4);

        if (!(typeof _this4.isAFlight === 'function')) {
            throw new TypeError('Value of "this.isAFlight" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this4.isAFlight));
        }

        _this4.isNotAFlight = _this4.isNotAFlight.bind(_this4);

        if (!(typeof _this4.isNotAFlight === 'function')) {
            throw new TypeError('Value of "this.isNotAFlight" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this4.isNotAFlight));
        }

        _this4.initVisibilityProps = _this4.initVisibilityProps.bind(_this4);

        if (!(typeof _this4.initVisibilityProps === 'function')) {
            throw new TypeError('Value of "this.initVisibilityProps" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this4.initVisibilityProps));
        }

        _this4.setFlightDetailsIsVisible = _this4.setFlightDetailsIsVisible.bind(_this4);

        if (!(typeof _this4.setFlightDetailsIsVisible === 'function')) {
            throw new TypeError('Value of "this.setFlightDetailsIsVisible" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this4.setFlightDetailsIsVisible));
        }

        _this4.setIsFlights = _this4.setIsFlights.bind(_this4);

        if (!(typeof _this4.setIsFlights === 'function')) {
            throw new TypeError('Value of "this.setIsFlights" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this4.setIsFlights));
        }

        return _this4;
    }

    (0, _createClass3.default)(FlightInformation, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props3 = this.props,
                setPassengerIdForFlightCheck = _props3.setPassengerIdForFlightCheck,
                paxId = _props3.paxId;

            if (paxId) setPassengerIdForFlightCheck(paxId);
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.generateIntlTicRenderProps(this.props);
            this.initVisibilityProps();
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps, nextState) {
            var error = nextProps.error;
            // If this 424 error is returned, we want to make the rest of the form "424-aware"
            // Also, we need to display a modal informing the user what to do next
            // But only display the modal once (not every time they submit, for eg.)

            if (error && error === 'FLIGHT_SEGMENT_ZERO_SCHEDULES_RETURNED') {
                this.setState({
                    is424: true
                });
                this.props.setIsZeroScheduleFlow(this.state.is424);
                if (!this.state.hasSeen424) {
                    this.props.updateUI('flight424Error', !this.props.flight424Error);
                }
                this.setState({
                    hasSeen424: true
                });
            }
        }
    }, {
        key: 'setFlightDetailsIsVisible',
        value: function setFlightDetailsIsVisible(flightIds) {
            this.setState({
                flightDetailsIsVisible: flightIds
            });
        }
    }, {
        key: 'setIsFlights',
        value: function setIsFlights(flightIds) {
            this.setState({
                isFlights: flightIds
            });
        }
    }, {
        key: 'showFlightDetails',
        value: function showFlightDetails(id) {
            if (!this.state.flightDetailsIsVisible.includes(id)) {
                this.setState({
                    flightDetailsIsVisible: [].concat((0, _toConsumableArray3.default)(this.state.flightDetailsIsVisible), [id])
                });
            }
        }
    }, {
        key: 'hideFlightDetails',
        value: function hideFlightDetails(id) {
            if (this.state.flightDetailsIsVisible.includes(id)) {
                this.setState({
                    flightDetailsIsVisible: this.state.flightDetailsIsVisible.filter(function (flightId) {
                        return flightId !== id;
                    })
                });
            }
        }
    }, {
        key: 'isAFlight',
        value: function isAFlight(id) {
            if (!this.state.isFlights.includes(id)) {
                this.setState({
                    isFlights: [].concat((0, _toConsumableArray3.default)(this.state.isFlights), [id])
                });
            }
        }
    }, {
        key: 'isNotAFlight',
        value: function isNotAFlight(id) {
            if (this.state.isFlights.includes(id)) {
                this.setState({
                    isFlights: this.state.isFlights.filter(function (flightId) {
                        return flightId !== id;
                    })
                });
            }
        }
    }, {
        key: 'generateIntlTicRenderProps',
        value: function generateIntlTicRenderProps(_ref4) {
            var intlTicReq = _ref4.requirementsByCode.INTERNATIONAL_TICKET_NUMBER;

            // Customer id won't change so we only need to do this once at component mount
            if (intlTicReq) {
                var customerId = intlTicReq.customer;
                this.setState({
                    intlTicRenderProps: (0, _forms.objInArrayFieldProps)({
                        findProp: 'customer.id',
                        findValue: customerId,
                        valueProp: 'ticket_number',
                        WrappedComponent: _components2.Input
                    })
                });
            }
        }
    }, {
        key: 'getFlights',
        value: function getFlights() {
            var _this5 = this;

            var arrivalFlights = this.props.requirementsByCode.ARRIVAL_FLIGHT_DETAILS || [];
            var departureFlights = this.props.requirementsByCode.DEPARTURE_FLIGHT_DETAILS || [];
            var flights = arrivalFlights.concat(departureFlights).sort(function (a, b) {
                var aDepService = _this5.props.departureServicesById[a.services[0].id];
                var bDepService = _this5.props.departureServicesById[b.services[0].id];
                if (aDepService.id === bDepService.id) {
                    // if same departure_service, order arrival before departure
                    return a.code === 'ARRIVAL_FLIGHT_DETAILS' ? -1 : 1;
                } else {
                    return aDepService.start_date < bDepService.start_date ? -1 : 1;
                }
            });

            return flights;
        }
    }, {
        key: 'initVisibilityProps',
        value: function initVisibilityProps() {
            var flights = this.getFlights();

            var visibleFlights = [];
            var flightFlights = [];

            flights.forEach(function (flight) {
                var uniqueFlightId = flight.customer + '-' + flight.code + '-' + flight.services[0].id;
                var overridePatchHref = flight.fieldResourceHrefsByType.overrides;
                if (!overridePatchHref) {
                    visibleFlights.push(uniqueFlightId);
                    flightFlights.push(uniqueFlightId);
                } else {
                    if (flightOverrideCodes.includes(flight.fieldValuesByResourceType.overrides.reason.code)) {
                        flightFlights.push(uniqueFlightId);
                    }
                }
            });

            this.setState({
                flightDetailsIsVisible: [].concat((0, _toConsumableArray3.default)(this.state.flightDetailsIsVisible), visibleFlights),
                isFlights: flightFlights
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this6 = this;

            var _props4 = this.props,
                intl = _props4.intl,
                array = _props4.array,
                change = _props4.change,
                initialValues = _props4.initialValues,
                hiddenValues = _props4.hiddenValues,
                requirementsByCode = _props4.requirementsByCode,
                paxId = _props4.paxId,
                departureServicesById = _props4.departureServicesById,
                paxProfile = _props4.paxProfile,
                bookingId = _props4.bookingId,
                isFetchingRequirementData = _props4.isFetchingRequirementData,
                resourceDataCall = _props4.resourceDataCall,
                customersById = _props4.customersById,
                handleSubmit = _props4.handleSubmit,
                error = _props4.error,
                invalid = _props4.invalid,
                pristine = _props4.pristine,
                submitting = _props4.submitting,
                submitSucceeded = _props4.submitSucceeded,
                submitFailed = _props4.submitFailed,
                bookingCompany = _props4.bookingCompany,
                bookingMeta = _props4.bookingMeta;

            // Combine arrival and departure flights and sort them appropriately
            // (will result in [ARRIVAL, DEPARTURE, ARRIVAL, DEPARTURE, ...] from earliest to latest tour)

            var flights = this.getFlights();
            var renderedDepServicesById = {};

            // Initialize patchHref for International Ticket # if exists for customer on this booking
            var intlTicReq = requirementsByCode.INTERNATIONAL_TICKET_NUMBER;
            var intlTicPatchHref = void 0;
            if (intlTicReq) {
                intlTicPatchHref = '[\'' + intlTicReq.fieldResourceHrefsByType.departure_services + '\']';
            }

            var forfeitedArrivalTransfer = requirementsByCode.FORFEITED_ARRIVAL_TRANSFER;
            var forfeitedDepartureTransfer = requirementsByCode.FORFEITED_DEPARTURE_TRANSFER;

            var showAlert = false; // switch to enable/disable alerts

            var showUnverifiedFlightsStub = false;
            if (requirementsByCode.UNVERIFIED_FLIGHTS) {
                showUnverifiedFlightsStub = true;
            }

            return _react3.default.createElement(
                'div',
                null,
                _react3.default.createElement(_components2.Flight424Modal, null),
                _react3.default.createElement(_components2.FormErrorMessage, { errorCode: error, invalid: invalid, submitFailed: submitFailed, submitting: submitting }),
                _react3.default.createElement(_components2.FormInstructionalText, {
                    instructionalText: _react3.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'formFlightInformation.instructionalText',
                        defaultMessage: 'Please provide only the arrival and departure segments of your flights.\n                                            If there are multiple segments, we only require the segments directly connecting\n                                            to your tour\'s starting and ending city.'
                    }) }),
                _react3.default.createElement(_components2.SameAsOtherPax, {
                    change: change,
                    requirements: flights,
                    paxId: paxId,
                    paxProfile: paxProfile,
                    array: array,
                    initialValues: initialValues,
                    flightDetailsIsVisible: this.state.flightDetailsIsVisible,
                    isFlights: this.state.isFlights,
                    setFlightDetailsIsVisible: this.setFlightDetailsIsVisible,
                    setIsFlights: this.setIsFlights,
                    departureServicesById: this.props.departureServicesById,
                    flightReqSets: this.props.flightReqSets
                }),
                showUnverifiedFlightsStub && _react3.default.createElement(_components2.FormStubText, { stubText: unverifiedFlightsStub() }),
                _react3.default.createElement(
                    'form',
                    null,
                    intlTicPatchHref && this.state.intlTicRenderProps && _react3.default.createElement(_components2.FieldSet, {
                        requirement: intlTicReq,
                        fields: [{
                            id: 'internationalTicketNumber',
                            label: _react3.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'flightInformation.internationalTicketNumber',
                                defaultMessage: 'International Ticket Number' }),
                            field: _react3.default.createElement(_reduxForm.Field, (0, _extends3.default)({
                                id: 'internationalTicketNumber',
                                name: intlTicPatchHref + '.international_ticket_numbers',
                                hiddenValues: hiddenValues,
                                type: 'text',
                                requirement: intlTicReq,
                                helpText: _react3.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'formFlightInformation.internationalTicketNumber.prompt',
                                    defaultMessage: '{internationalTicketNumberText}',
                                    values: {
                                        internationalTicketNumberText: _react3.default.createElement(
                                            'div',
                                            null,
                                            _react3.default.createElement(
                                                'p',
                                                null,
                                                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'formFlightInformation.internationalTicketNumber.prompt.part1',
                                                    defaultMessage: 'The 13 digit E-Ticket number, assigned to each flight passenger, is found on your international air ticket itinerary.' }),
                                                _react3.default.createElement('br', null),
                                                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'formFlightInformation.internationalTicketNumber.prompt.part2',
                                                    defaultMessage: 'Examples: (Valid number in bold)' })
                                            ),
                                            _react3.default.createElement(
                                                'ul',
                                                null,
                                                _react3.default.createElement(
                                                    'li',
                                                    null,
                                                    _react3.default.createElement(
                                                        'strong',
                                                        null,
                                                        '1234567891234'
                                                    )
                                                ),
                                                _react3.default.createElement(
                                                    'li',
                                                    null,
                                                    '99-',
                                                    _react3.default.createElement(
                                                        'strong',
                                                        null,
                                                        '1234567891234'
                                                    )
                                                )
                                            )
                                        )
                                    }
                                })
                            }, this.state.intlTicRenderProps))
                        }, (0, _extends3.default)({}, (0, _forms.generateOverride)({
                            intl: intl,
                            id: 'intlTicOverride',
                            requirement: requirementsByCode.INTERNATIONAL_TICKET_NUMBER,
                            overrideLabels: _forms2.formOverrides.flightInformation.INTERNATIONAL_TICKET_NUMBER,
                            bookingId: bookingId,
                            initialValues: initialValues
                        }))] }),
                    forfeitedArrivalTransfer && _react3.default.createElement(
                        'div',
                        null,
                        _react3.default.createElement(_components2.FormStubText, { stubText: forfeitedTransferStub.FORFEITED_ARRIVAL_TRANSFER(bookingCompany, bookingMeta) }),
                        _react3.default.createElement(_components2.FieldSet, {
                            requirement: forfeitedArrivalTransfer,
                            fields: [(0, _extends3.default)({}, (0, _forms.generateOverride)({
                                intl: intl,
                                id: 'forfeitedArrivalTransfer',
                                requirement: forfeitedArrivalTransfer,
                                overrideLabels: _forms2.formOverrides.transferAcknowledgements,
                                bookingId: bookingId,
                                initialValues: initialValues
                            }))] })
                    ),
                    forfeitedDepartureTransfer && _react3.default.createElement(
                        'div',
                        null,
                        _react3.default.createElement(_components2.FormStubText, { stubText: forfeitedTransferStub.FORFEITED_DEPARTURE_TRANSFER() }),
                        _react3.default.createElement(_components2.FieldSet, {
                            requirement: forfeitedDepartureTransfer,
                            fields: [(0, _extends3.default)({}, (0, _forms.generateOverride)({
                                intl: intl,
                                id: 'forfeitedDepartureTransfer',
                                requirement: forfeitedDepartureTransfer,
                                overrideLabels: _forms2.formOverrides.acknowledgements,
                                bookingId: bookingId,
                                initialValues: initialValues
                            }))] })
                    ),
                    flights.map(function (flight, i) {
                        var isArrival = flight.code === 'ARRIVAL_FLIGHT_DETAILS';
                        var associatedDepartureFlight = void 0,
                            assocDFDepService = void 0; // Associated Departure Flight departure_service
                        if (i > 0 && isArrival && flights[i - 1].code === 'DEPARTURE_FLIGHT_DETAILS') {
                            associatedDepartureFlight = flights[i - 1];
                            assocDFDepService = departureServicesById[associatedDepartureFlight.services[0].id];
                        }
                        var departureService = departureServicesById[flight.services[0].id];
                        var flightDetailProps = {
                            change: change,
                            flight: flight,
                            bookingId: bookingId,
                            departureService: departureService,
                            assocDFDepService: assocDFDepService,
                            array: array,
                            initialValues: initialValues,
                            hiddenValues: hiddenValues,
                            resourceDataCall: resourceDataCall,
                            flightType: flight.code === 'ARRIVAL_FLIGHT_DETAILS' ? 'ARRIVAL' : 'DEPARTURE',
                            intl: intl,
                            flightLabelId: 'flight-' + i,
                            // ui props
                            showFlightDetails: _this6.showFlightDetails,
                            hideFlightDetails: _this6.hideFlightDetails,
                            flightDetailsIsVisible: _this6.state.flightDetailsIsVisible,
                            isAFlight: _this6.isAFlight,
                            isNotAFlight: _this6.isNotAFlight,
                            isFlights: _this6.state.isFlights,
                            uniqueFlightId: flight.customer + '-' + flight.code + '-' + flight.services[0].id,
                            is424: _this6.state.is424

                            // Ensure we separate each tour's flights
                        };var addSeparator = false;
                        if (!renderedDepServicesById[departureService.id]) {
                            addSeparator = true;
                            renderedDepServicesById[departureService.id] = true;
                        }
                        return _react3.default.createElement(
                            'div',
                            { key: i, className: (0, _classnames2.default)({ 'tour-separator': addSeparator }) },
                            addSeparator && _react3.default.createElement('div', { className: 'separator-line' }),
                            _react3.default.createElement(FlightDetails, flightDetailProps)
                        );
                    }),
                    paxProfile && showAlert && _react3.default.createElement(_components2.FieldSet, {
                        noRequirement: true,
                        fields: [{
                            id: 'smsFlightAlerts',
                            label: _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'formContactInformation.smsFlightAlerts' }),
                            field: _react3.default.createElement(_reduxForm.Field, (0, _extends3.default)({
                                id: 'smsFlightAlerts',
                                name: '[\'' + paxProfile.href + '\'].notification_preferences',
                                type: 'checkbox'
                            }, (0, _forms.objInArrayFieldProps)({
                                findProp: 'code',
                                findValue: 'SMS_FLIGHT_ALERTS',
                                valueProp: 'subscribed',
                                WrappedComponent: _components2.Input,
                                isCheckbox: true
                            })))
                        }, {
                            id: 'emailFlightAlerts',
                            label: _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'formContactInformation.emailFlightAlerts' }),
                            field: _react3.default.createElement(_reduxForm.Field, (0, _extends3.default)({
                                id: 'emailFlightAlerts',
                                name: '[\'' + paxProfile.href + '\'].notification_preferences',
                                type: 'checkbox'
                            }, (0, _forms.objInArrayFieldProps)({
                                findProp: 'code',
                                findValue: 'EMAIL_FLIGHT_ALERTS',
                                valueProp: 'subscribed',
                                WrappedComponent: _components2.Input,
                                isCheckbox: true
                            })))
                        }] }),
                    _react3.default.createElement(_components2.FormSubmit, {
                        handleSubmit: handleSubmit,
                        invalid: invalid,
                        pristine: pristine,
                        submitting: submitting,
                        submitSucceeded: submitSucceeded,
                        isFetchingRequirementData: isFetchingRequirementData })
                )
            );
        }
    }]);
    return FlightInformation;
}(_react2.Component), _class5.propTypes = {
    intl: _propTypes2.default.object.isRequired,
    initialValues: _propTypes2.default.object.isRequired,
    requirementsByCode: _propTypes2.default.object.isRequired,
    resourceDataCall: _propTypes2.default.object,
    bookingId: _propTypes2.default.string.isRequired,
    departureServicesById: _propTypes2.default.object.isRequired,
    paxProfile: _propTypes2.default.object,
    setPassengerIdForFlightCheck: _propTypes2.default.func.isRequired,
    setIsZeroScheduleFlow: _propTypes2.default.func.isRequired,
    paxId: _propTypes2.default.string.isRequired,
    isFetchingRequirementData: _propTypes2.default.bool.isRequired,
    handleSubmit: _propTypes2.default.func.isRequired,
    error: _propTypes2.default.string,
    invalid: _propTypes2.default.bool,
    pristine: _propTypes2.default.bool,
    submitting: _propTypes2.default.bool,
    submitSucceeded: _propTypes2.default.bool,
    submitFailed: _propTypes2.default.bool,
    bookingMeta: _propTypes2.default.object
}, _temp2)) || _class4) || _class4) || _class4) || _class4) || _class4));

exports.default = FlightInformation;

function _inspect(input, depth) {
    var maxDepth = 4;
    var maxKeys = 15;

    if (depth === undefined) {
        depth = 0;
    }

    depth += 1;

    if (input === null) {
        return 'null';
    } else if (input === undefined) {
        return 'void';
    } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
        return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
    } else if (Array.isArray(input)) {
        if (input.length > 0) {
            if (depth > maxDepth) return '[...]';

            var first = _inspect(input[0], depth);

            if (input.every(function (item) {
                return _inspect(item, depth) === first;
            })) {
                return first.trim() + '[]';
            } else {
                return '[' + input.slice(0, maxKeys).map(function (item) {
                    return _inspect(item, depth);
                }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
            }
        } else {
            return 'Array';
        }
    } else {
        var keys = (0, _keys2.default)(input);

        if (!keys.length) {
            if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
                return input.constructor.name;
            } else {
                return 'Object';
            }
        }

        if (depth > maxDepth) return '{...}';
        var indent = '  '.repeat(depth - 1);
        var entries = keys.slice(0, maxKeys).map(function (key) {
            return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
        }).join('\n  ' + indent);

        if (keys.length >= maxKeys) {
            entries += '\n  ' + indent + '...';
        }

        if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
            return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
        } else {
            return '{\n  ' + indent + entries + '\n' + indent + '}';
        }
    }
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/components/RequirementSet/forms/FlightInformation.js
// module id = 1321
// module chunks = 0